(() => {
  const teaserSelector = '[data-testid="animated-teaser"]';
  const klaviyoHeadingSelector = 'form.klaviyo-form h1';

  const removeTeaser = (root) => {
    const teasers = [];

    if (root instanceof Element && root.matches(teaserSelector)) {
      teasers.push(root);
    }

    if (root.querySelectorAll) {
      teasers.push(...root.querySelectorAll(teaserSelector));
    }

    teasers.forEach((teaser) => {
      const teaserRoot = teaser.closest('[class*="kl-teaser"]') || teaser.parentElement || teaser;
      teaserRoot.remove();
    });
  };

  const downgradeKlaviyoHeading = (root) => {
    const headings = [];

    if (root instanceof Element && root.matches(klaviyoHeadingSelector)) {
      headings.push(root);
    }

    if (root.querySelectorAll) {
      headings.push(...root.querySelectorAll(klaviyoHeadingSelector));
    }

    headings.forEach((heading) => {
      const replacement = document.createElement('div');

      [...heading.attributes].forEach((attribute) => {
        replacement.setAttribute(attribute.name, attribute.value);
      });

      while (heading.firstChild) {
        replacement.appendChild(heading.firstChild);
      }

      heading.replaceWith(replacement);
    });
  };

  removeTeaser(document);
  downgradeKlaviyoHeading(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          removeTeaser(node);
          downgradeKlaviyoHeading(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
